import React from "react";
import { getFeaturedMarketLabel } from "../../utility/complianceCopy";
import { isDTS } from "../../utility/platform";
import "./matchOddsGrid.css";

function OddsGridCell({ cell, variant = "spread" }) {
  if (!cell?.hasValue) {
    return <span className="match-odds-grid__cell match-odds-grid__cell--empty">—</span>;
  }

  if (variant === "h2h") {
    return (
      <span className="match-odds-grid__cell">
        {cell.label ? (
          <span className="match-odds-grid__point">{cell.label}</span>
        ) : null}
        <span className="match-odds-grid__price">{cell.display}</span>
      </span>
    );
  }

  if (variant === "total") {
    return (
      <span className="match-odds-grid__cell">
        <span className="match-odds-grid__point">{cell.point}</span>
        <span className="match-odds-grid__price">{cell.price}</span>
      </span>
    );
  }

  return (
    <span className="match-odds-grid__cell">
      <span className="match-odds-grid__point">{cell.point}</span>
      <span className="match-odds-grid__price">{cell.price}</span>
    </span>
  );
}

/** Read-only Spread / M-Line / Total grid — matches center panel layout. */
export default function MatchOddsGrid({ grid, className = "" }) {
  if (!grid?.hasOdds || !Array.isArray(grid.rows) || grid.rows.length === 0) {
    return null;
  }

  const headers =
    grid.headers ||
    ["Spread", getFeaturedMarketLabel("h2h", isDTS()), "Total"];

  return (
    <div className={`match-odds-grid ${className}`.trim()} aria-label="Match odds">
      <div className="match-odds-grid__headers">
        {headers.map((label) => (
          <span key={label} className="match-odds-grid__header">
            {label}
          </span>
        ))}
      </div>
      {grid.rows.map((row, rowIndex) => (
        <div key={`odds-row-${rowIndex}`} className="match-odds-grid__row">
          <OddsGridCell cell={row.spreads} variant="spread" />
          <OddsGridCell cell={row.h2h} variant="h2h" />
          <OddsGridCell cell={row.totals} variant="total" />
        </div>
      ))}
    </div>
  );
}
